module.exports = __webpack_public_path__ + "static/media/expandIcon.669881f7.svg";